import { render, staticRenderFns } from "./saveMediaMix.vue?vue&type=template&id=3b277f40&"
import script from "./saveMediaMix.vue?vue&type=script&lang=js&"
export * from "./saveMediaMix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports